import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Flagsmith: gates the redesigned "Auto-fill the transcript" mic-test step
 * (mahogany one-tap CTA + single-line "Use your own voice" row) against the
 * previous "Play a sample conversation" step.
 *
 * - ON  → `MicTestStep` (auto-fill redesign)
 * - OFF → `MicTestStepPlaySample` (previous production design)
 */
export function useIsMicTestAutofillEnabled(): boolean {
  return useBooleanFlagValue('release-onboarding-mic-test-autofill', false);
}
